import { INTERACTION_STATE_ACTIVE, INTERACTION_STATE_HOVER, INTERACTION_STATE_SCROLLING, } from '../../../../constants';
import { getBoxShadow as getGlobalBoxShadow } from './global';
export function getBoxShadow(transformer) {
    const globalBoxShadow = getGlobalBoxShadow(transformer);
    return Object.freeze({
        container: { value: globalBoxShadow.close },
        pageHeader: {
            interactionStates: {
                [INTERACTION_STATE_SCROLLING]: { value: globalBoxShadow.far },
            },
        },
        pageFooter: { value: globalBoxShadow.extraFar },
        form: {
            switchKnob: { value: globalBoxShadow.close },
        },
        iconButton: {
            attentional: { value: globalBoxShadow.close },
        },
        modal: { value: globalBoxShadow.far },
        button: {
            primary: {
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalBoxShadow.close },
                    [INTERACTION_STATE_ACTIVE]: { value: globalBoxShadow.close },
                },
            },
            secondary: {
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalBoxShadow.close },
                    [INTERACTION_STATE_ACTIVE]: { value: globalBoxShadow.close },
                },
            },
            add: {
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalBoxShadow.close },
                    [INTERACTION_STATE_ACTIVE]: { value: globalBoxShadow.close },
                },
            },
        },
    });
}
